import { routeContactUsPage } from '@components/ContactUsPage';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useHeaderNavLinks = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        label: t('common:renewPolicy'),
        to: '/user-dashboard/policy',
      },
      {
        label: t('common:contactUs'),
        to: routeContactUsPage(),
      },
    ],
    [],
  );
};
